module.exports = __webpack_public_path__ + "static/media/M mall shot 02.png2.3a379f1a.webp";